import { useLinks } from 'core/components/linksContext';
import { button, buttonAccent } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { formatToLocalDayMonthYearDot } from 'core/utils';
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'site/components/auth/AuthProvider';

type ILinkAccessProps = {} & WithStyles<typeof styles>;

const LinkAccess: React.FC<ILinkAccessProps> = ({ classes }) => {
    const {
        myAccount: { accessToFreeForms },
    } = useAuth();
    const links = useLinks();

    return (
        <div className={classes.root}>
            {accessToFreeForms && (
                <p className={classes.active}>У вас есть доступ до {formatToLocalDayMonthYearDot(accessToFreeForms)}</p>
            )}
            <p>
                Доступ к просмотру видеозаписей и материалов бесплатных мероприятий предоставляется при условии покупки
                любого курса в текущем календарном году.
            </p>
            <Link className={classes.button} to={links.courseList.url()}>
                Выбрать курс
            </Link>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '1rem 1.5rem',
            border: '1px solid rgba(0, 0, 0, 0.2)',
            fontSize: 16,
            lineHeight: 18 + 'px',
        },
        active: {
            color: theme.colors.accent,
            fontWeight: 'bold',
            marginBottom: 1 + 'rem',
        },
        button: {
            ...button(theme),
            ...buttonAccent(theme),
            fontWeight: 'bold',
            fontSize: 14,
            margin: 'auto auto 0 auto',
            width: 150,
        },
    });

export default injectSheet(styles)(LinkAccess);
